import { colors } from '@procore/core-react';
import makeStyles from '@mui/styles/makeStyles';

export const useStyles = makeStyles((theme) => ({
  projectHeaderContainer: {
    padding: '37px 0 0px 0',
    [theme.breakpoints.down(960)]: {
      paddingTop: '5px',
    },
  },
  projectHeader: {
    flexDirection: 'row',
    [theme.breakpoints.down(960)]: {
      flexDirection: 'column',
    },
  },
  projectNameContainer: {
    width: '100%',
    [theme.breakpoints.up(960)]: {
      marginTop: '4px',
    },
  },
  mainInfoContainer: {
    marginBottom: '10px',
    flexDirection: 'row',
    [theme.breakpoints.down(960)]: {
      marginTop: '16px',
      flexDirection: 'column',
    },
  },
  projectName: {
    fontSize: '44px',
    lineHeight: '48px',
    fontStyle: 'normal',
    fontWeight: 700,
    marginBottom: '12px',
    [theme.breakpoints.down(960)]: {
      fontSize: '28px',
      lineHeight: '36px',
      fontStyle: 'normal',
      fontWeight: 700,
      marginBottom: '0px',
    },
  },
  descriptiveInfo: {
    margin: '0 10px 0 5px',
    fontSize: '16px',
    fontWeight: 400,
    textWrap: 'wrap',
  },
  descriptionWithIconAndTitleText: {
    fontSize: '14px!important',
    lineHeight: '20px',
    fontWeight: 400,
  },
  descriptionWithIconAndTitleLink: {
    '&, &:hover, &:focus, &:active': {
      textDecoration: 'underline',
      color: colors.blue45,
      outline: 0,
      display: 'block',
    },
    '&:hover': { color: colors.black },
    '&:focus-visible': {
      boxShadow: `0px 0px 0px 2px ${colors.blue50}`,
    },
    '&> p': {
      fontSize: '14px !important',
      fontWeight: '400 !important' as any,
      textWrap: 'wrap',
    },
  },
  aboutContainer: {
    marginTop: '25px',
  },
  aboutTitle: {
    marginBottom: '20px',
    [theme.breakpoints.down(600)]: {
      marginBottom: '12px',
    },
  },
  about: {
    fontSize: '18px',
    lineHeight: '24px',
    fontWeight: 400,
  },
  headerLink: {
    '&, &:hover, &:focus, &:active': {
      textDecoration: 'underline',
      color: colors.blue45,
      outline: 0,
      display: 'block',
    },
    '&:hover': { color: colors.black },
    '&:focus-visible': {
      boxShadow: `0px 0px 0px 2px ${colors.blue50}`,
    },
    '&> p': {
      fontSize: '16px !important',
      fontWeight: '400 !important' as any,
      textWrap: 'wrap',
    },
  },
  showMoreOrLessText: {
    color: colors.black,
    display: 'inline-block',
    fontSize: '18px',
    textDecoration: 'underline',
    '&:hover': { cursor: 'pointer' },
  },
  descriptiveInfoContainer: {
    alignItems: 'baseline',
    marginBottom: '12px',
    flexDirection: 'row',
    [theme.breakpoints.down(960)]: {
      alignItems: 'flex-start',
      marginTop: '12px',
      marginBottom: '5px',
    },
  },
  ndaContainer: {
    marginTop: '15px',
  },
  ndaTitle: {
    display: 'flex',
    alignItems: 'center',
  },
  lockedShieldIcon: {
    marginRight: '10px',
  },
  ndaDescription: {
    marginTop: '12px',
    fontSize: '18px',
    lineHeight: '24px',
    fontWeight: 400,
  },
}));
